/**
 * hellopanda-onoff
 */
const HELLOPANDA_ONOFF = {
  init: function() {

    const _ = this;

    // 전역 객체 생성
    window.hellopanda = window.hellopanda || {} ;
    const setting = window.hellopanda.onoff;

    if (setting) {
      // 타이밍을 위해서 바로 실행
      // document.addEventListener('DOMContentLoaded', function() {
        const onoffs = document.querySelectorAll('.wp-block-hellopanda-onoff-block');
        onoffs.forEach(element => {

          let on = false;
          let rule_home = element.dataset.home;
          let rule_url = element.dataset.url || '' ;
          let rule_category = element.dataset.category || '' ;

          const urls = rule_url
          .replace(/\\n/g, '\n') // \n을 실제 줄바꿈으로 복원
          .split('\n')
          .map(url => url.trim())
          .filter(url => url);
        
          const categories = rule_category
          .replace(/\\n/g, '\n') // \n을 실제 줄바꿈으로 복원
          .split('\n')
          .map(category => category.trim())
          .filter(category => category);

          if (rule_home === 'true' && _.isRoot(setting.url)) {
            on = true;
          }
          if (urls.length) {
            const encodedUrls = urls.map(url => _.customEncodeURIComponent(url.replaceAll(' ', '-')));
            on = encodedUrls.some(encodedUrl => setting.url?.toLowerCase().includes(encodedUrl.toLowerCase()));
          }
          if (categories.length) {
            const encodedCategories = categories.map(category =>
              _.customEncodeURIComponent(category.replaceAll(' ', '-'))
            );
            if (encodedCategories.some(encodedCategory =>
              setting.category?.some(category =>
                category.toLowerCase().includes(encodedCategory.toLowerCase())
              )
            )) {
              on = true;
            }
          }

          // 예외처리 : 카테고리에 글이 없다면 카테고리가 빈값으로 오기 때문에 예외적으로 url 과 비교한다.
          if (!on && categories && !setting.category?.length && setting.url?.includes('/category/')) {
            const encodedEmptyCategories = categories.map(category => _.customEncodeURIComponent(category.replaceAll(' ', '-')));
            on = encodedEmptyCategories.some(encodedCategory => setting.url?.toLowerCase().includes(encodedCategory.toLowerCase()));
          }

          if (on) {
            element.setAttribute('data-onoff', 'on');
          }

        });
      // });
    }
  },
  isRoot: function() {

    const url = new URL(window.location.href);
      
    // URL의 경로가 빈 문자열이거나 '/'인지 확인
    const isRootPath = url.pathname === '' || url.pathname === '/';
    
    // 검색 파라미터와 해시가 비어 있는지 확인
    const hasNoSearchParams = !url.search || url.search === '?';
    const hasNoHash = !url.hash || url.hash === '#';
    
    // 모든 조건이 만족되면 true 반환
    return isRootPath && hasNoSearchParams && hasNoHash;

  },
  customEncodeURIComponent: function(url) {
    return url
    .split(/([:/=?])/g) // :, /, =, ? 문자를 유지하고 나머지를 분리
    .map(part => (part.match(/[:\/=?]/) ? part : encodeURIComponent(part))) // 유지할 문자와 나머지를 조건부로 처리
    .join('');
  }
};
HELLOPANDA_ONOFF.init();